export enum PaymentMethods {
    CreditCard = 1,
    Ach = 2,
    Zip = 100,
}
